/**
 * @file
 * Attach the accordion as behavior.
 */

(function ($, Drupal) {
  Drupal.behaviors.accordion = {
    attach: function attach(context) {
      const $accordion = $('.accordion');
      $accordion.createAccordion({
        trigger: ".accordion__title",
        content: ".accordion__content"
      });
      $(document).on('aw.accordion.opened', function(event){
        // Any contained slick slider needs to be refreshed to prevent display issues.
        $(event.target).find('.slick-slider').slick('refresh');
      });
    }
  };
})(jQuery, Drupal);
